import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MerchantReportUserLinkDTViewModel } from '../../../models/merchant-report-user-link-dt-view-model';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthenticationService } from '../../../services/authentication.service';
import { ReportService } from '../../../services/report.service';
import { UserDataStoreService } from '../../../services/user-data-store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IdTextPair } from '../../../models/id-text-pair';
import { GenericReportViewModel } from '../../../models/generic-report-view-model';
import { GenericTransactionsViewModel } from '../../../models/generic-transactions-view-model';
import { DatePipe } from '@angular/common';
import { GroupGenericTransactionsViewModel } from '../../../models/group-generic-transactions-view-model';
import { PermissionEnum } from '../../../services/guards/permissions';
import * as moment from 'moment';
import { GiftCardReportViewModel, GiftCardTransactionsViewModel, GroupGiftCardTransactionsViewModel, GroupReconTransactionsViewModel, ReconTransactionsViewModel } from "../../../models/recon-report-view-model";
import { DailyMerchantReportUserLinkViewModel } from '../../../models/daily-merchant-report-user-link-view-model';
import { RawTransactionReportComponent } from '../raw-transaction-report/raw-transaction-report.component';
import { ReconciledTransactionReportComponent } from '../reconciled-transaction-report/reconciled-transaction-report.component';
import { GiftCardTransactionReportComponent } from '../giftcard-transaction-report/giftcard-transaction-report.component';
import { validateFormHelper } from '../../../merchant-sign-up/sign-up/Common-helpers/validate-form';
import { ExceptionCardReportComponent } from '../exception-card-report/exception-card-report.component';

@Component({
  selector: 'transaction-report-base',
  templateUrl: './transaction-report-base.component.html',
  styleUrls: ['./transaction-report-base.component.scss']
})

export class TransactionReportComponent extends validateFormHelper implements OnInit {

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};
  dropDownForm: FormGroup;
  selectedItems: Array<{ item_id: number; item_text: string }> = [];
  merchantNameLocation: string;
  public reportForm: FormGroup;
  hasMultipleMerchants!: boolean;
  selectedMerchant!: string;
  selectedTerminal!: string;
  raiseWarning: boolean;
  message: string;
  alertType: string;
  public merchants: MerchantReportUserLinkDTViewModel[];
  public merchantOptions: { id: string; text: string }[] = [];
  public dailyMerchantReport: DailyMerchantReportUserLinkViewModel[];

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };
  public merchantsPair: IdTextPair[];
  public terminalsPair: IdTextPair[];
  submitted: boolean = false;
  genericReport: GenericReportViewModel;
  transactions: GenericTransactionsViewModel[] = [];
  public canView: boolean;
  isVisible: boolean;
  public popupWin: any;
  reportType: string = 'raw';

  groupedTerminals: { postTranId: number; pan: string; datetimeReq: string; tranType: string; totalsGroup: string; amountAvailable: number; terminalId: string; items: any[] }[] = [];
  grandTotalForTerminals: number = 0;
  print: boolean = false;
  groupGenericTransactionsViewModel: GroupGenericTransactionsViewModel[] = [];

  reconTransactions: ReconTransactionsViewModel[] = [];
  groupedReconTerminals: GroupReconTransactionsViewModel[] = [];
  grandTotalForReconTerminals: number = 0;
  groupReconTransactionsViewModel: GroupReconTransactionsViewModel[] = [];

  giftCardReport: GiftCardReportViewModel;
  giftCardTransactions: GiftCardTransactionsViewModel[] = [];
  grandTotalForGiftCardTerminals: number = 0;
  groupedGiftCardTerminals: GroupGiftCardTransactionsViewModel[] = [];

  canViewGiftCardReport: boolean = false;
  canViewReconReport: boolean = false;
  canViewRawReport: boolean = false;
  canViewExceptionCardReport: boolean = false;
  canViewQrReport: boolean = false;
  showCardType: boolean = true;

  baseStartDate = '';
  baseEndDate = '';
  formattedDate = '';
  formattedFullName = '';

  @ViewChild(RawTransactionReportComponent) _rawTransactionComponent: RawTransactionReportComponent;
  @ViewChild(GiftCardTransactionReportComponent) _giftCardTransactionComponent: GiftCardTransactionReportComponent;
  @ViewChild(ReconciledTransactionReportComponent) _reconTransactionComponent: ReconciledTransactionReportComponent;
  @ViewChild(ExceptionCardReportComponent) _exceptionCardReportComponent: ExceptionCardReportComponent;

  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private loader: NgxUiLoaderService,
    private _reportService: ReportService,
    private _formBuilder: FormBuilder,
    private fb: FormBuilder,
    private datePipe: DatePipe) {
    super();
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewGenericReport]);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

    this.canViewGiftCardReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewGiftCardReport], []);
    this.canViewReconReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewReconReport], []);
    this.canViewRawReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewRawReport], []);
    this.canViewExceptionCardReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewExceptionReport], []);
    this.canViewQrReport = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewQrReport], []);
  }

  async ngOnInit() {

    this.dropdownList = [
      { item_id: '00', item_text: 'Purchase' },
      { item_id: '01', item_text: 'Withdrawal' },
      { item_id: '20', item_text: 'Returns' },
      { item_id: '21', item_text: 'Deposit' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
    };

    this.selectedItems = [];
    this.dropDownForm = this.fb.group({
      myItems: [this.selectedItems]
    });


    this.loader.start();
    this.reportForm = this._formBuilder.group({
      startDate: [this.setDate(-1), Validators.required],
      endDate: [this.setDate(0), Validators.required],
      selectedMerchant: ['', Validators.required],
      selectedTerminal: ['All'],
      reportType: ['raw', Validators.required],
      transactionType: [''],
      totalsGroup: [''],
      myItems: [[]]
    });

    debugger;
    var user = this._userDataStore.currentUserValue.id;
    this.dailyMerchantReport = await this._reportService.GetDailyMerchantsByUser(user);
    this.merchantsPair = this.dailyMerchantReport.map((x) => ({
      id: x.usnNumber.toString(),
      text: x.usnNumber.toString() + " " + x.nameLocation,
    }));

    if (this.canViewRawReport) {
      this.reportForm.controls['reportType'].setValue('raw');
      this.reportType = 'raw';
      //this._changeDetectorRef.detectChanges();
    }
    else if (this.canViewReconReport) {
      this.reportForm.controls['reportType'].setValue('recon');
      this.reportType = 'recon';
      //this._changeDetectorRef.detectChanges();
    }
    else if (this.canViewGiftCardReport) {
      this.reportForm.controls['reportType'].setValue('gift');
      this.reportType = 'gift';
      //this._changeDetectorRef.detectChanges();
    }
    else if (this.canViewExceptionCardReport) {
      this.reportForm.controls['reportType'].setValue('exception');
      this.reportType = 'exception';
      //this._changeDetectorRef.detectChanges();
    } 
    this.loader.stop();
  }

  getReportTypeName(): string {
  
    switch (this.reportType) {
      case 'raw':
        return 'Transaction report';
      case 'recon':
        return 'Recon report';
      case 'giftcard':
        return 'Gift card report';
      case 'exception':
        return 'Exception switch only report';
      case 'qr':
        return 'QR transaction report';
      default:
        return 'Report';
    }
  }

  onReportTypeChange() {
    debugger;
    this.reportType = this.reportForm.controls['reportType'].value;
    this.showCardType = true;
    if (this.reportType == "giftcard") {
      this.showCardType = false;
    }
    this.reset();
  }

  setDate(d: number): String {
    const today = new Date();
    today.setDate(today.getDate() + d);
    const dateOnly = today.toISOString().split('T')[0];
    return dateOnly;
  }

  reset() {
    this.groupedTerminals = null;
    this.groupedReconTerminals = [];
    this.groupedGiftCardTerminals = [];
    this.grandTotalForTerminals = 0;
    this.grandTotalForReconTerminals = 0;
    this.grandTotalForGiftCardTerminals = 0;
    this.isVisible = false;
    this.raiseWarning = false;
    //this.reportForm.controls['startDate'].setValue(this.setDate(-1));
    //this.reportForm.controls['endDate'].setValue(this.setDate(0));
    this.reportForm.controls['selectedMerchant'].setValue('');
    this.reportForm.controls['totalsGroup'].setValue('');
    this.reportForm.markAsUntouched();
    this.dropDownForm.reset();
    // dropDownForm.reset() only clears the control; selectedItems is what gets
    // posted as transactionType, so it has to be cleared alongside it.
    this.selectedItems = [];
  }

  async resetAll() {
    this.reset();
    this.reportForm.controls['reportType'].setValue('raw');
    this.raiseWarning = false;
  }

  baseConvertToDecimal(amount?: string | number | null): string {
    if (amount == null) return "0.00";

    const cleanNumber = parseFloat(amount.toString().replace(',', '.'));
    if (isNaN(cleanNumber))
      return "0.00";

    return cleanNumber.toFixed(2);
  }

  formatDateTime(dateReq: string): string {
    const adjustedDate = new Date(dateReq);
    adjustedDate.setHours(adjustedDate.getHours() - 2);

    const pad = (n: number) => n.toString().padStart(2, '0');

    return [
      adjustedDate.getFullYear(),
      pad(adjustedDate.getMonth() + 1),
      pad(adjustedDate.getDate())]
      .join('-') + ' ' + [
        pad(adjustedDate.getHours()),
        pad(adjustedDate.getMinutes()),
        pad(adjustedDate.getSeconds())
      ].join(':');
  }

  formatFirstAndLastName(first: string, last: string): string {
    return `${first} ${last}`;
  }

  onFormatDate(date: string) {
    this.formattedDate = this.formatDateTime(date);
  }

  onFormatName(data: { first: string; last: string }) {
    this.formattedFullName =
      this.formatFirstAndLastName(data.first, data.last);
  }

  async submit() {
    debugger;
    if (this.reportForm.valid) {
      this.isVisible = false;
      this.raiseWarning = false;

      this.loader.start();
      this.baseStartDate = this.reportForm.controls['startDate'].value;
      this.baseEndDate = this.reportForm.controls['endDate'].value;
      this.reportType = this.reportForm.controls['reportType'].value;

      this.genericReport = {
        startDate: this.reportForm.controls['startDate'].value,
        endDate: this.reportForm.controls['endDate'].value,
        merchant: this.reportForm.controls['selectedMerchant'].value,
        terminal: this.reportForm.controls['selectedTerminal'].value,
        totalsGroup: this.reportForm.controls['totalsGroup'].value,
        transactionType: JSON.stringify(this.selectedItems),
      };

      if (this.reportType === 'recon') {
        if (!this.canViewReconReport)
          return;
        await this._reconTransactionComponent.GetReport(this.genericReport);
        this.isVisible = this._reconTransactionComponent.hasValue;
        this.raiseWarning = this._reconTransactionComponent.raiseWarning;

      } else if (this.reportType === 'giftcard') {
        if (!this.canViewGiftCardReport)
          return;
        await this._giftCardTransactionComponent?.GetReport(this.genericReport);
        this.isVisible = this._giftCardTransactionComponent.hasValue;
        this.raiseWarning = this._giftCardTransactionComponent.raiseWarning;

      } else if (this.reportType === 'raw') {
        if (!this.canViewRawReport)
          return;
        await this._rawTransactionComponent?.GetReport(this.genericReport, 'raw');
        this.isVisible = this._rawTransactionComponent.hasValue;
        this.raiseWarning = this._rawTransactionComponent.raiseWarning;
      }
      else if (this.reportType === 'qr') {
        if (!this.canViewQrReport)
          return;
        await this._rawTransactionComponent?.GetReport(this.genericReport, 'qr');
        this.isVisible = this._rawTransactionComponent.hasValue;
        this.raiseWarning = this._rawTransactionComponent.raiseWarning;
      }
      else {
        if (!this.canViewExceptionCardReport)
          return;
        await this._exceptionCardReportComponent?.GetReport(this.genericReport);
        this.isVisible = this._exceptionCardReportComponent.hasValue;
        this.raiseWarning = this._exceptionCardReportComponent.raiseWarning;
      }

      if (this.raiseWarning) {
        this.message = "No results found. Please adjust your search criteria";
        this.alertType = "warning";
      }

      this.loader.stop();
    }
    else {
      this.markAsTouched(this.reportForm);
      this.message = "Please fill all required fields";
      this.raiseWarning = true;
      this.alertType = "danger";
    }
  }

  async onSelectedMerchant(USSNumber: string) {

    if (USSNumber != '') {
      this.loader.start();
      var merchantId = 0;
      for (var i = 0; i < this.dailyMerchantReport.length; i++) {
        if (this.dailyMerchantReport[i].usnNumber === USSNumber) {
          merchantId = this.dailyMerchantReport[i].merchantId
          break;
        }
      }

      const getTerminals = await this._reportService.GetTerminalsByUSSNumber(USSNumber, merchantId);
      this.terminalsPair = getTerminals.map((x) => ({
        id: x.terminalNumber.toString(),
        text: x.terminalNumber.toString()
      }));

      this.terminalsPair.push({ id: "All", text: "All" });
      this.terminalsPair.sort((a, b) => a.text.localeCompare(b.text));
      this.loader.stop();
    }
  }

  onItemSelect(item: any) {
    const exists = this.selectedItems.some(x => x.item_id === item.item_id);
    if (!exists) {
      this.selectedItems.push(item);
    }
  }

  onItemDeSelect(item: any) {
    const idx = this.selectedItems.findIndex(x => x.item_id === item.item_id);
    if (idx > -1) {
      this.selectedItems.splice(idx, 1);
    }
  }

  onSelectAll(items: any[]) {
    this.selectedItems = [...items];
  }

  onUnSelectAll() {
    this.selectedItems.length = 0;
  }

  isAllSelected(): boolean {
    const currentSelection = this.dropDownForm.get('myItems')?.value || [];
    return currentSelection.length === this.dropdownList.length;
  }

  checkStatus() {
    if (this.isAllSelected()) {
    }
  }

  printTable(): void {
    var title: string, compId: string;
    if (this.reportType === 'recon') {
      title = 'Recon Report';
      compId = 'recon-component-id';
    }
    else if (this.reportType === 'giftcard') {
      title = 'Giftcard Report';
      compId = 'giftcard-component-id';
    } else if (this.reportType === 'raw') {
      title = 'Transaction Report';
      compId = 'raw-component-id';
    } else if (this.reportType === 'qr') {
      title = 'QR Transaction Report';
      compId = 'raw-component-id';
    } else {
      title = 'Exceptioncard Report';
      compId = 'exception-component-id';
    }

    this.print = true;
    const printContents = document.getElementById(compId)?.innerHTML;

    if (printContents) {
      this.popupWin = window.open('', '_blank', 'top=50,left=1,height=100%,width=auto');
      this.popupWin.document.open();
      this.popupWin.document.write(`
    <html>
      <head>
        <title>${title}</title>
         <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
    </html>`
      );
      this.popupWin.document.close();
    }
  }

  csvExport(): void {

    const today = new Date();
    const currentDate = moment(today).format('YYYY-MM-DD-THHmm');

    let data: Array<ReconTransactionsViewModel | GiftCardTransactionsViewModel | GenericTransactionsViewModel> = [];

    var fileName = '';
    if (this.reportType === 'recon') {
      data = this._reconTransactionComponent.transactionReport;
      fileName = `${this._reconTransactionComponent.merchantNameLocation.trimRight()} Recon Report ${currentDate}.csv`;
    }
    else if (this.reportType === 'giftcard') {
      data = this._giftCardTransactionComponent.transactionReport;
      fileName = `${this._giftCardTransactionComponent.merchantNameLocation.trimRight()} GiftCard Report ${currentDate}.csv`;
    } else if (this.reportType === 'raw') {
      data = this._rawTransactionComponent.transactionReport;
      fileName = `${this._rawTransactionComponent.merchantNameLocation.trimRight()} Transaction Report ${currentDate}.csv`;
    }
    else if (this.reportType === 'qr') {
      data = this._rawTransactionComponent.transactionReport;
      fileName = `${this._rawTransactionComponent.merchantNameLocation.trimRight()} QR Transaction Report ${currentDate}.csv`;
    }
    else {
      data = this._exceptionCardReportComponent.transactionReport;
      fileName = `${this._exceptionCardReportComponent.merchantNameLocation.trimRight()} Exception switch only report ${currentDate}.csv`;
    }

    if (!data.length) {
      return;
    }

    const replacer = (key, value) => (value === null ? '' : value);
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
